import { Comment } from './comment.model';

/**
 * Represents the user tasks.
 */
export class Task {
    type: TYPE;
    id: string;
    taskDefId: string;
    title: string;
    dueDate: Date;
    description: string;
    owner: string;
    assignee: string;
    entityName: string;
    delegationState: string;
    decisions: Array<string>;
    taskChoices: TaskChoices;
    comments: Array<Comment>;
    entityId: number;
    // client-side props.
    newComment: Comment;
    addFirstComment: boolean;
    isSubmitted: boolean;
    // @todo temp.
    entityType: string;
    orgPersonId: number;
    workflowName:string;
    submitted:string;
    endDate:string;
}

export enum TYPE {
    ADHOC = <any>'ADHOC',
    WORKFLOW = <any>'WORKFLOW',
}

export class TaskChoices {
    name: string;
    choices: Object;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/task.model.ts